// @ts-nocheck
import React, { Component } from "react";
import { withRouter } from '../../utils/routerCompat';
import { Treebeard } from "./Treebeard";
import customTheme from "./themes/customTheme";
import decorators from "./decorators";
import ApiService from "../../services/api.service";
import slugify from "slugify";
import { connect } from "react-redux";

class TheKanbanBoardTree extends Component {
  constructor(props) {
    super(props);
    this.state = { data: [] };
    this.apiService = ApiService.getInstance();
  }
  componentDidMount() {
    // JIRA INTEGRATION DISABLED - Only load tree data for non-DEFAULT boards that are not JIRA
    // if (this.props.boardType !== "DEFAULT" && this.props.boardType !== "JIRA") this.getTreeData();
    // Jira integration disabled - no tree data loading
  }

  componentWillReceiveProps(nextProps, nextState) {
    // JIRA INTEGRATION DISABLED
    // if (nextProps.boardType !== "DEFAULT" && nextProps.boardType !== "JIRA" && nextProps.boardType !== this.props.boardType) {
    //   this.getTreeData();
    // } else if (nextProps.boardType === "DEFAULT" && nextProps.boardType !== this.props.boardType) {
    //   this.setState({ data: [] });
    // }
    // Always clear tree data since Jira is disabled
    if (this.state.data && this.state.data.children) {
      this.setState({ data: [] });
    }
  }

  setBoardData = payload => {
    const boardData = {
      ...payload,
      color: payload.color === "green" ? "theme-grey" : payload.color
    };
    const lists = {};
    const cards = {};
    boardData.lists = boardData.lists.map(item => {
      lists[item._id] = item;
      lists[item._id].cards = lists[item._id].cards.map(card => {
        cards[card._id] = card;
        return card._id;
      });
      return item._id;
    });

    this.props.dispatch({
      type: "SET_CARDS",
      payload: cards
    });
    this.props.dispatch({
      type: "SET_LISTS",
      payload: lists
    });
    this.props.dispatch({
      type: "SET_BOARD",
      payload: boardData
    });
  };

  async getTreeData() {
    // JIRA INTEGRATION DISABLED
    // await this.apiService
    //   .get(`/boards/boardtreemodel`)
    //   .then(res => {
    //     if (res.success) {
    //       const { payload } = res;
    //       payload.toggled = true;
    //       this.setState({ data: payload });
    //     } else {
    //     }
    //   })
    //   .catch(err => {});
    console.warn("Jira integration disabled - getTreeData() not available");
  }

  find(query) {}

  setChildrenData = (rootlevel, prevData, newData, toggled, node) => {
    (rootlevel ? prevData.children : prevData.children.children).every(item => {
      if (item.id === node.id) {
        item.children = newData;
        item.toggled = toggled;
      }

      return item.id !== node.id;
    });

    return prevData;
  };

  onToggle = async (node, toggled) => {
    const rootlevel = Boolean(node.directoryName === "root");
    const issueTypeLevel = Boolean(node.elementType === "issueType");

    const { cursor, data } = this.state;
    if (cursor) {
      cursor.active = false;
    }

    // JIRA INTEGRATION DISABLED
    // if (rootlevel) {
    //   await this.apiService
    //     .get(`/boards/boardtreemodel/boardid/${node.id}`)
    //     .then(res => {
    //       if (res.success) {
    //         const latestData = this.setChildrenData(
    //           rootlevel,
    //           JSON.parse(JSON.stringify(data)),
    //           res.payload.children[0].children,
    //           toggled,
    //           node
    //         );

    //         latestData.children.forEach((item, index) => {
    //           item.level = 1;
    //           item.index = index;
    //           if (item.children && item.children.length) {
    //             item.children.forEach((child, childIndex) => {
    //               child.parentIndex = index;
    //               child.level = 2;

    //               if (child.children && child.children.length) {
    //                 child.children.forEach(subChildItem => {
    //                   subChildItem.subparentIndex = childIndex;
    //                   subChildItem.parentIndex = index;
    //                   subChildItem.level = 3;
    //                   subChildItem.parentIssueType = child.name;

    //                   if (subChildItem.children && subChildItem.children.length) {
    //                     subChildItem.children.forEach(subChild => {
    //                       subChild.lastElement = true;
    //                       subChild.parentIssueType = subChildItem.name;
    //                     });
    //                   }
    //                 });
    //               }
    //             });
    //           }
    //         });

    //         this.setState({ data: latestData });
    //         node.children = latestData.children;
    //       }
    //     })
    //     .catch(err => console.warn(err));
    // } else if (issueTypeLevel) {
    //   if (!node.toggled) {
    //     if (node.elementType !== "sprint") {
    //       await this.apiService
    //         .get(`/boards/issue/issuetype/${node.id}/boardid/${this.state.data.children[node.parentIndex].id}`)
    //         .then(res => {
    //           if (res.success) {
    //             this.setBoardData(res.payload);
    //             return;
    //           }
    //         })
    //         .catch(err => console.warn(err));
    //     }
    //   }
    // }
    console.warn("Jira integration disabled - tree operations not available");

    // Handle node toggling for non-Jira boards
    if (node.children && node.children.length) {
      node.toggled = toggled;
    }

    node.active = !node.active;
    if (node.children && node.children.length) {
      node.toggled = toggled;
    }
    this.setState(
      () => ({ cursor: node }),
      () => {
        if ((node.toggled || node.toggled === undefined) && node.elementType !== "sprint") {
          const { cursor } = this.state;
          if (rootlevel) {
            this.props.history.push(
              `/b/${cursor.id}/${slugify(cursor.name, {
                lower: true
              })}`
            );
          }
        }
      }
    );
  };

  render() {
    let stateData = this.state && this.state.data;
    return (
      <div className="aside-holder" style={{ marginTop: "80px", height: "85%" }}>
        {stateData && stateData.children && (
          <div className="tree-beard-container" onMouseUp={() => {}}>
            <Treebeard
              data={stateData}
              style={customTheme}
              decorators={decorators}
              animations={false}
              onToggle={this.onToggle}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    boardType: state.boardType
  };
};

export default withRouter(connect(mapStateToProps)(TheKanbanBoardTree));
